import { useTranslation } from 'react-i18next';

import { Box, Container, Typography } from '@mui/material';

import PageHeader from '../components/PageHeader';

import { useUpdateDocumentMeta } from '../hooks/useUpdateDocumentMeta';

import { useSelector } from 'react-redux';
import { getTranslation } from '../utils/translate';
import Wysiwyg from '../components/Wysiwyg';

function ContestShortRules() {
    const { t } = useTranslation(['translations', 'faqs']);

    useUpdateDocumentMeta(t('rules', { ns: 'faqs' }));

    const { code: languageCode } = useSelector(state => state.language);

    const contests = useSelector(state => state.contests);
    const contest = contests?.find(item => item?.id) || null;

    let contestRules = '';

    if (contest) {
        const translatedContest = getTranslation(contest, { key: 'languages_code', code: languageCode });

        contestRules = translatedContest?.short_rules || '';
    }

    return (
        <>
            <Box className="beef-product-brand-page">
                <Container maxWidth disableGutters
                    sx={{ p: 0 }}
                >
                    <Box>
                        <PageHeader 
                            item={{
                                name: t('rules', { ns: 'faqs'}),
                            }}
                            useAsLink={false}
                        />
                    </Box>
                </Container>

                <Container
                    disableGutters
                    sx={{
                        my: 5
                    }}
                >
                    <Container
                        className='padding-on-mobile'
                        sx={{
                            my: 6
                        }}
                    >
                        <Typography>
                            <Wysiwyg>
                                {contestRules}
                            </Wysiwyg>
                        </Typography>
                    </Container>
                </Container>
            </Box>
        </>
    )
}

export default ContestShortRules